var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "input-box" }, [
    _c("label", { staticClass: "label-text" }, [
      _vm._v(_vm._s(_vm.label) + " *"),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-group" }, [
      _c("span", { staticClass: "la la-phone form-icon" }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.displayModel,
            expression: "displayModel",
          },
        ],
        staticClass: "form-control",
        attrs: {
          id: _vm.uuId,
          type: "tel",
          autocomplete: "off",
          placeholder: "Telefon Numarası",
        },
        domProps: { value: _vm.displayModel },
        on: {
          input: function ($event) {
            if ($event.target.composing) {
              return
            }
            _vm.displayModel = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c("span", {
        staticClass: "hide error-text",
        attrs: { id: _vm.uuId + "error-msg" },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }